// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class ShaftResource extends Resource {
    basePath: string = 'networks/shafts/';

    objectPath: string = 'networks/shafts/{ident}/';

    createSingle(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}create-single/`,
            'POST', query,
        ).then((response) => response.data);
    }

    map(mapUuid: string, query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}${mapUuid}/map/`,
            'GET', query,
        ).then((response) => response.data);
    }
}
